import { useMsal, useIsAuthenticated, useAccount } from "@azure/msal-react";
import { useCallback } from "react";
import { loginRequest, msalConfig, isAuthConfigured } from "./msalConfig";

export function useAuth() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const accountFromHook = useAccount();
  const account =
    accountFromHook ||
    instance.getActiveAccount() ||
    (accounts && accounts[0]) ||
    null;

  const login = useCallback(() => {
    return instance.loginRedirect(loginRequest);
  }, [instance]);

  const logout = useCallback(() => {
    const activeAccount = instance.getActiveAccount();
    if (activeAccount) {
      return instance.logoutRedirect({
        account: activeAccount,
        postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
      });
    }
    return Promise.resolve();
  }, [instance]);

  return {
    isAuthenticated,
    isAuthConfigured: isAuthConfigured(),
    account,
    login,
    logout,
  };
}
